export interface ProxyModel {
  id: string;
  address: string;
  port: number;
  username: string;
  password: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateProxyRequest {
  address: string;
  port: number;
  username: string;
  password: string;
  active?: boolean;
}

export interface UpdateProxyRequest {
  address?: string;
  port?: number;
  username?: string;
  password?: string;
  active?: boolean;
}

export interface ListProxiesQuery {
  pageSize?: number;
  pageIndex?: number;
  search?: string;
}

export interface ListProxiesResponse {
  items: ProxyModel[];
  total: number;
  pageIndex: number;
  pageSize: number;
  totalPages: number;
}

export interface BulkCreateProxiesRequest {
  proxies: CreateProxyRequest[];
}

export interface BulkProxyResultResponse {
  affected: number;
}

/** Below this many GB left, proxy usage is surfaced as a warning instead of a quiet indicator. */
export const PROXY_ALERT_GB = 25;

export interface ProxyUsage {
  plan: string;
  username: string;
  bytes_used: number;
  max_bytes: number;
  remaining_bytes: number;
  gb_used: number;
  gb_total: number;
  gb_remaining: number;
  percent_used: number;
  low_balance: boolean;
}
